import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col, Card, Table, Button, Spinner, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from '../../common/Avatar';
import { item } from '../../../lib/api/entities';
import { getDocumentStatus } from '../../../lib/api/document';
import { list, remove, processMembership } from '../../../lib/api/membership';
import { Add } from './Add';
import { Edit } from './Edit';
import CardDropdown from 'components/common/CardDropdown';
import { Dropdown } from 'react-bootstrap';
import { useAppContext } from '../../../providers/AppProvider';
import SubtleBadge from '../../common/SubtleBadge';
import PaginationEllipsis from '../../common/PaginationEllipsis';
import SearchAccordion from '../../common/SearchAccordion';

export const List = () => {
  const { userApp, refreshNotification } = useAppContext();
  const entities_guide = localStorage.getItem('entities_guide');

  const [search, setSearch] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState([]);
  const [mode, setMode] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [membership, setMembership] = useState(null);
  const [entities, setEntities] = useState(null);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramsObj = Object.fromEntries(queryParams.entries());

  const handlePageChange = newPage => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  const handleNew = () => {
    setMembership(null);
    setShowModal(true);
  };

  const handleEdit = id => {
    const currentMembership = documents.find(c => c.membership_guid === id);
    setMembership(currentMembership);
    setMode('edit');
    setShowModal(true);
  };

  const handleView = id => {
    const currentMembership = documents.find(c => c.membership_guid === id);
    setMembership(currentMembership);
    setMode('view');
    setShowModal(true);
  };

  const handleProcess = async (document_guid, nextStatus) => {
    try {
      const processed = await processMembership(document_guid, {
        documents_status_id: nextStatus.documents_status_id
      });
      setDocuments(prev =>
        prev.map(p => (p.document_guid === processed.document_guid ? processed : p))
      );
      refreshNotification();
    } catch (err) {
      toast.error(
        <span>
          <p>Doslo je do greske.</p>
          <p>{err.body?.message || err.message}</p>
        </span>
      );
    }
  };

  const handelDelete = async id => {
    setIsLoading(true);
    try {
      if (confirm(`Da li ste sigurni da zelite da izbrisete dokument?${String(id)}`)) {
        await remove(id);
        setDocuments(documents.filter(item => item.document_guid !== id));
      }
    } catch (error) {
      console.error('Failed to delete item', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getDocuments = () => {
    list({ entities_guide })
      .then(res => {
        setDocuments(res.data);
        setTotalPages(res.totalPages);
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (userApp.entities_guide) {
          const rowEntities = await item(userApp.entities_guide);
          setEntities(rowEntities);
        }

        const rowDoc = await list({ ...{ entities_guide, page, pageSize }, ...search });
        setDocuments(rowDoc.data);
        setTotalPages(rowDoc.totalPages);

        const rowStatus = await getDocumentStatus({ document_type_id: 8 });
        setStatus(rowStatus);

        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [userApp, page, pageSize, search]);

  const findStatus = id => {
    const status_id = id === 10 ? 11 : 10;
    const index = status.findIndex(statusItem => statusItem.documents_status_id === status_id);
    return status[index];
  };

  const getFormattedDate = item => format(item.date_created, 'dd.MM.yyyy');

  const renderActions = item => (
    <CardDropdown>
      <div className="py-2">
        <Dropdown.Item onClick={() => handleView(item.membership_guid)}>
          Pregled dokumenta
        </Dropdown.Item>
        {item.documents_status_id !== 12 && (
          <>
            {item.documents_status_id === 10 && (
              <>
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => handleEdit(item.membership_guid)}>
                  Izmjena
                </Dropdown.Item>
                <Dropdown.Divider />
              </>
            )}
            {userApp.role_type_id === 'clubs' ? (
              <>
                <Dropdown.Item
                  onClick={() => handleProcess(item.document_guid, findStatus(item.documents_status_id))}
                >
                  {findStatus(item.documents_status_id)?.name}
                </Dropdown.Item>
              </>
            ) : (
              <>
                {status.map((cat, i) => (
                  <Dropdown.Item
                    key={i}
                    onClick={() => handleProcess(item.document_guid, cat)}
                  >
                    {cat.alt_name}
                  </Dropdown.Item>
                ))}
              </>
            )}
            {item.documents_status_id === 10 && (
              <>
                <Dropdown.Divider />
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => handelDelete(item.document_guid)}
                >
                  Delete
                </Dropdown.Item>
              </>
            )}
          </>
        )}
      </div>
    </CardDropdown>
  );

  return (
    <Row className="g-2">
      <SearchAccordion
        document_type_id={8}
        paramsObj={paramsObj}
        handleSearch={data => {
          setSearch(data);
        }}
      />
      <Col xs={12}>
        <Card className={classNames('h-100')}>
          <Card.Header>
            <Row className={classNames('g-2')}>
              <Col>
                <Flex>
                  <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                    Pristupnica - Promjena clanstva
                  </h5>
                </Flex>
              </Col>
              <Col xs="auto">
                <Button onClick={handleNew} variant="primary">
                  +
                </Button>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="bg-body-tertiary">
            {isLoading ? (
              <div className="text-center">
                <Spinner animation="border" role="status" />
              </div>
            ) : (
              <Row className="mb-3">
                <div className="d-none d-xl-block">
                  <Table responsive className="mb-0">
                    <thead>
                      <tr>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        <th className="text-start" scope="col">
                          ID
                        </th>
                        <th scope="col">Datum</th>
                        <th scope="col">Ime i prezime</th>
                        <th scope="col" className="text-center">
                          Status
                        </th>
                        <th className="text-end" scope="col">
                          Akcija
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {documents.map((item, i) => (
                        <tr key={i}>
                          <td>
                            <div className="ms-2">
                              <Avatar
                                src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                                size="l"
                                name={item.short_name_club}
                              />
                            </div>
                          </td>
                          <td className="text-nowrap">
                            <div className="d-flex align-items-center">
                              <div className="ms-2">
                                <small>{item.short_name_club}</small>
                              </div>
                            </div>
                          </td>
                          <td className="text-nowrap">
                            <div className="d-flex align-items-center">
                              <div className="ms-2">{item.document_id}</div>
                            </div>
                          </td>
                          <td>
                            <div className="ms-2">{getFormattedDate(item)}</div>
                          </td>
                          <td>
                            <div className="ms-2">
                              {item.name_player}{' '}
                              <span className="badge rounded-pill badge-subtle-warning">
                                {item.documents_status_id !== 12 ? item.name_club : ''}
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            <SubtleBadge bg={item.color} className="fs-10">
                              {item.status_name}
                            </SubtleBadge>
                          </td>
                          <td className="text-end">{renderActions(item)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-xl-none">
                  <Row className="g-3">
                    {documents.map((item, i) => (
                      <Col xs={12} key={item.membership_guid || item.document_guid || i}>
                        <div
                          className="border rounded-4 bg-white h-100 p-3 shadow-sm cursor-pointer"
                          style={{ borderColor: '#dfe3ee' }}
                          onClick={() => handleView(item.membership_guid)}
                        >
                          <div className="d-flex align-items-start justify-content-between gap-3">
                            <div className="flex-shrink-0">
                              <Avatar
                                src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                                size="2xl"
                                name={item.short_name_club}
                              />
                            </div>
                            <div
                              className="flex-shrink-0"
                              onClick={event => event.stopPropagation()}
                            >
                              {renderActions(item)}
                            </div>
                          </div>

                          <div className="mt-3">
                            <div className="fw-semibold text-dark fs-8">
                              {item.name_player || '-'}
                            </div>

                            <div className="d-flex flex-wrap gap-2 mt-2">
                              <span className="badge rounded-pill badge-subtle-primary">
                                {item.document_id || '-'}
                              </span>
                            </div>

                            <div className="text-700 fs-10 mt-2">
                              {item.name_club || item.short_name_club || '-'}
                            </div>

                            <div className="mt-2">
                              <SubtleBadge bg={item.color} className="fs-10">
                                {item.status_name}
                              </SubtleBadge>
                            </div>

                            <div className="text-600 fs-10 mt-2">{getFormattedDate(item)}</div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Row>
            )}
          </Card.Body>
          <Card.Footer>
            {totalPages > 1 && (
              <Row className="justify-content-center">
                <PaginationEllipsis
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </Row>
            )}
          </Card.Footer>

          <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Promjena clanstva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {membership ? (
                <Edit
                  initMembership={membership}
                  initMode={mode}
                  onClose={() => setShowModal(false)}
                  onSave={getDocuments}
                />
              ) : (
                <Add onClose={() => setShowModal(false)} onSave={getDocuments} />
              )}
            </Modal.Body>
          </Modal>
        </Card>
      </Col>
    </Row>
  );
};

export default List;
